import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/california_endangered_species': {
    callist: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'callist',
            type: PaintColorTypes.CATEGORICAL,
            stops: [
              { value: 'Threatened', color: '#a6cee3' },
              { value: 'Delisted', color: '#1f78b4' },
              { value: 'None', color: '#b2df8a' },
              { value: 'Candidate Endangered', color: '#33a02c' },
              { value: 'Endangered', color: '#fb9a99' },
              { value: 'Candidate Threatened', color: '#e31a1c' },
              { value: 'Rare', color: '#fdbf6f' },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
